import r1 from '../assets/receipts/1.pdf';
import r2 from '../assets/receipts/2.pdf';
import r3 from '../assets/receipts/3.pdf';
import r4 from '../assets/receipts/4.pdf';
import r5 from '../assets/receipts/5.pdf';
import r6 from '../assets/receipts/6.pdf';
import r7 from '../assets/receipts/7.pdf';
import r8 from '../assets/receipts/8.pdf';
import r9 from '../assets/receipts/9.pdf';
import r10 from '../assets/receipts/10.pdf';
import r11 from '../assets/receipts/11.pdf';
import r12 from '../assets/receipts/12.pdf';
import r15 from '../assets/receipts/15.pdf';
import r16 from '../assets/receipts/16.pdf';

const useReceipts = () => {
    const receipts = {
        1: r1,
        2: r2,
        3: r3,
        4: r4,
        5: r5,
        6: r6,
        7: r7,
        8: r8,
        9: r9,
        10: r10,
        11: r11,
        12: r12,
        15: r15,
        16: r16,
    };
    return receipts;
}

export default useReceipts